'use strict';

angular.module('clientDashboardApp').directive('brandRestrictions',function(){

  BrandRestrictionsCtrl.$inject = ['$scope','configService'];

  return {
    restrict: 'A',
    template: require('./BrandRestrictions.html'),
    scope: {
      account: '=',
      config: '='
    },
    controller:BrandRestrictionsCtrl,
  }


  function BrandRestrictionsCtrl($scope,configService){
    var vm = this;

    getBrandConfig($scope.account.id)

    $scope.brandRestrictionFields = [];
    $scope.tempRestrictions = {};
    $scope.configSettings = {};
    $scope.loadingBrandConfig = true;
    $scope.brandRestrictionChanges = {};
    $scope.save = false;

    $scope.$watch('config.save',function(newVal,oldVal){
      if(newVal == true && newVal !== oldVal){
        $scope.saveChanges();
      }
    })

    $scope.saveChanges = function(){
      $scope.config.state.updating = true;
      _.mapObject($scope.tempRestrictions,function(val,key){
          $scope.tempRestrictions[key] = !$scope.configSettings[key].checked;
      });

      configService.updateBrandRestrictions($scope.account.id,$scope.tempRestrictions).then(function(resp){
        getBrandConfig($scope.account.id);
        $scope.config.state.success = true;
        $scope.config.state.updating = false;
      });


      $scope.config.save = false;
    }

    $scope.updateConfigChanges = function(field){
      if($scope.configSettings[field] !== !$scope.brandConfig.restrictions[field].value){
        $scope.brandRestrictionChanges[field] = !$scope.configSettings[field];
      }
    }

    function mapRestrictions(){
      $scope.brandRestrictionFields = [];
      _.map($scope.tempRestrictions,function(value,key){
        $scope.brandRestrictionFields.push(key);
      });
      _.each($scope.brandRestrictionFields,function(item){
        $scope.configSettings[item] = {
          name : item.replace("hide","Show").replace(/([a-z])([A-Z])/g,"$1 $2"),
          checked : !$scope.tempRestrictions[item]
        }
      });
    }

    function getBrandConfig(accountId) {
      configService.getBrandConfigForAccount(accountId).then(function(res){
        $scope.brandConfig = res.data.config;
        $scope.sparseConfig = res.data.sparse;
        angular.copy($scope.brandConfig.restrictions,$scope.tempRestrictions);
        mapRestrictions();
        $scope.loadingBrandConfig = false;
      })
    }

  }



});
